import React, { useState, useRef } from "react";
import { Col, Container, Modal, Row, Button, Spinner } from 'react-bootstrap';
import IRTPU from "./Actions/IRTPU";
import Penalize from "./Penalize";
import CabInOutForm from "./CabInOutForm";
import AtLocation from "./Actions/AtLocation";
import PickedUp from "./Actions/PickedUp";
import Dropped from "./Actions/Dropped";
import { useSelector } from "react-redux";
import SendNotificationActions from "../AdminFunctions/SendNotification";
import DriverSearch from "./Actions/DriverSearch";
import AgentNotesDialog from "../AgentNotes/AgentNotesDialog";
import ColorCodesActions from "../AdminFunctions/ColorCodes";
import AlertBox from "../../common/alert";
import EmailCustomer from "../AdminFunctions/EmailCustomer";
import APICom from "../../../utils/helpers/APICom";
import PersistStorage from "../../../utils/helpers/PersistStorage";



const DriverActionsDialog = (props) => {

    const { loginData } = useSelector((store) => store.login);
    const [isProcessing, setIsProcessing] = useState(false);
    const [irtpuComponentLoaded, setIRTPUComponentLoad] = useState(false);
    const [atlocationProcessing, setAtLocationProcessing] = useState(false);
    const [atlocationComponentLoaded, setATLOCATIONComponentLoad] = useState(false);
    const [pickedupProcessing, setPickedUpProcessing] = useState(false);
    const [pickedupComponentLoaded, setPickedUpComponentLoad] = useState(false);
    const [droppedProcessing, setDroppedProcessing] = useState(false);
    const [droppedComponentLoaded, setDroppedComponentLoad] = useState(false);
    const [driversearchComponentLoaded, setDriverSearchComponentLoad] = useState(false);
    const [sendNotificationComponentLoaded, setSendNotificationComponentLoad] = useState(false);
    const [agentInstructionComponentLoaded, setAgentInstructionComponentLoad] = useState(false);
    const [colorCodesComponentLoaded, setColorCodesComponentLoad] = useState(false);
    const [emailCustomerComponentLoad, setEmailCustomerComponentLoad] = useState(false);
    const [showPenalty, setShowPenalty] = useState(false);
    const [showFavor, setShowFavor] = useState(false);
    const [showInOut, setShowInOut] = useState(false);
    const [responseBody, setResponseBody] = useState({alertTitle: '', alertMsg:''});
    const [title, setTitle] = useState("-1");
    const [body, setBody] = useState("-1");
    const [showAlert, setShowAlert] = useState(false);
    const favorRef = useRef(null);
  
    const handleCloseDriverActionsDialog = () => {
        if (props.showDriverActionsDialog) {
            props.setDriverActionsDialog(false);
            let IsDriverActionsDialogOpened = PersistStorage.retrieve("IsDriverActionsDialogOpened", false);
            if(IsDriverActionsDialogOpened != undefined && IsDriverActionsDialogOpened != null)
            {
                PersistStorage.save("IsDriverActionsDialogOpened", false, 0, false);
            }
        }
    }
    const handleDriverPenalty = () => {
        setShowPenalty(true);
    }
        const handleDriverFavor = async () => {
        if (props.GridRowData.length < 1)
        {
            setTitle('Driver Favor');
            setBody("No Row Selected to give Favor!");
            setShowAlert(true);
            setShowInOut(false);
            return
        } 
        if(props.GridRowData !== undefined)
        {
            // vehNo = props.GridRowData[0].VEHNo
            favorRef.current.innerHTML = "<span role='status' aria-hidden='true' class='spinner-border spinner-border-sm'></span>";
            var isSpecial = 0;
            let iAssignedVehicleId = props.GridRowData[0].iAssignedVehicleId;
            let AssignedDriverId = props.GridRowData[0].AssignedDriverId;
            let ServiceID = props.GridRowData[0].ServiceID;
            let sDriverId =  props.GridRowData[0].iSpecialDriverId;
            let sVehicleId = props.GridRowData[0].iSpecialVehicleId;
            var zoneID, Result,isMDTSelected ;
            if (props.GridRowData[0].VEHNo.includes("-R"))
            {
                isSpecial = 1;
                if (sVehicleId === undefined || sVehicleId === null || sVehicleId == "" || 
                    sDriverId === undefined || sDriverId === null || sDriverId === "")
                {
                    setTitle('Driver Favor');
                    setBody("No Driver or Vehicle is assigned to this trip!");
                    setShowAlert(true);
                    return;
                }
            }
            else if(iAssignedVehicleId === undefined || iAssignedVehicleId === null || iAssignedVehicleId === "" || 
                AssignedDriverId === undefined || AssignedDriverId === null || AssignedDriverId === "")
            {
                isSpecial = 0;
                setTitle('Driver Favor');
                setBody("No Driver or Vehicle is assigned to this trip!");
                setShowAlert(true);
                return;
            }
            if (isSpecial === 1)
            {
                iAssignedVehicleId = sVehicleId;
                AssignedDriverId = sDriverId;
            }         
            let response = await APICom.fetchData("", "DispatchActions/GetVehicleZoneInfo?driverId=" + AssignedDriverId + "&vehicleId=" + iAssignedVehicleId, "get", { "Content-Type": "application/json" }, null, null);
            if (response !== null)
            {
                //console.log('response')
                if(response.data.length > 0)
                {
                    zoneID = String(response.data[0]["iVZoneID"]);
                    isMDTSelected = String(response.data[0]["bisMDT"]);
                    Result = "success";
                }
                else
                {
                    zoneID = "-1";
                    isMDTSelected = "0";
                    Result = "success";
                }
            }    
            else
            {
                zoneID = "-1";
                isMDTSelected = "0";
                Result = "success";
            }
                
            if (zoneID === "-1")
            {
                favorRef.current.innerHTML = "FAVOR";
                setShowInOut(true);
            }
            else
            {
                
                try{
                    var Param = {
                        "iDriverID": parseInt(AssignedDriverId),
                        "iVehicleID": parseInt(iAssignedVehicleId),
                        "iServiceID": parseInt(ServiceID),
                        "vReason": "",
                        "iCreatedByUID": parseInt(loginData.iUserID)
                    }
            
                    await APICom.fetchData("", "DispatchActions/insertDriverFavor", "post", { "Content-Type": "application/json" }, Param, null);
                
                }        
                catch
                {
                    setTitle('Failure!');
                    setBody("Error on inserting Favor!");
                    setShowAlert(true);
                    favorRef.current.innerHTML = "FAVOR";
                    return;
                }
                try {
                    var Param1 = {
                        "iVehicleID": parseInt(iAssignedVehicleId),
                        "forceBookIn": true,
                        "iVZoneID": parseInt(zoneID),
                        "iPriorty": '1',
                        "bisMDT": false,
                        "isBookIn": true,
                        "bBookedInByDevice": false,
                        "bIsInStand": false,
                        "vReason": "Book_In",
                        "iUserID": parseInt(loginData.iUserID),
                    }
        
                    let response = await APICom.fetchData("", "DispatchActions/insertVehicleInZone", "post", { "Content-Type": "application/json" }, Param1, null);
                    // console.log(response)
                    if (response !== null)
                    {
                        setTitle('Success!!');
                        setBody("Vehicle Book_In Successfully!");
                        setShowAlert(true);
                        favorRef.current.innerHTML = "FAVOR";
                    }
                    else
                    {
                        setTitle('Failure!');
                        setBody("Vehicle-BookIn Failed!");
                        setShowAlert(true);
                        favorRef.current.innerHTML = "FAVOR";
                    }
                }
                catch
                {
                    //console.log('ERROR');
                }
            }                        
        }
        else{
            setTitle('Driver Favor');
            setBody("No Row Selected to give Favor!");
            setShowAlert(true);
            favorRef.current.innerHTML = "FAVOR";
            return;
        }
    }

    const handleDriverActionIRTPU = () => {
        setIRTPUComponentLoad(true);
        setIsProcessing(true);
    }

    const handleSendNotification = () => {
        setSendNotificationComponentLoad(true);

    }

    const handleDriverActionDriverSearch = () => {
        setDriverSearchComponentLoad(true);
     }

    const handleDriverActionATLOCATION = () => {
        setATLOCATIONComponentLoad(true);
        setAtLocationProcessing(true);
    }

    const handleDriverActionPU = () => {
        setPickedUpComponentLoad(true);
        setPickedUpProcessing(true);
    }

    const handleDriverActionDO = () => {
        setDroppedComponentLoad(true);
        setDroppedProcessing(true);
    }

    const handleAgentInstructionClick = () => {
        setAgentInstructionComponentLoad(true);
    }

    const handleColorCodes = () => {
        setColorCodesComponentLoad(true);
    }

    const handleEmailCustomerClick = () => {
        setEmailCustomerComponentLoad(true);
    }

    const RefreshGridData = () => {
        if(typeof props.ReloadDataFunction === 'function'){
            props.ReloadDataFunction();
        }
    }

    return (
        <>
            <Modal show={props.showDriverActionsDialog ? 1 : 0} centered onHide={handleCloseDriverActionsDialog} backdrop="static" keyboard={true} size={(props.gridType !== 'Complete' ? "xl" : "lg")} animation={true}
                aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header className='activate_dialog_header_bgcolor' closeButton>
                    <Modal.Title className="activate_dialog_title_color user-select-none">
                        Driver Controls 
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="grid-example">
                    <Container>
                        <Row>
                            <Col xs={6} md={3} className="w-100 user-select-none">Trip #:<b className="mx-2">{props.GridRowData.length > 0 ? (props.GridRowData[0]["ConfirmationNo"] ? props.GridRowData[0]["ConfirmationNo"] : props.GridRowData[0]["Confirmation #"]) : ""}</b></Col>
                        </Row>
                        <Row className="tripaction_btn_seperator"></Row>
                        <h5 className="user-select-none">Driver Actions</h5>
                        {props.gridType !== 'Complete' ?
                            <Row>
                                <Col xs={6} md={3}>
                                    <Button className="tripaction_btn_color tripaction_btn_width" onClick={handleDriverActionIRTPU} value="IRTPU" disabled={isProcessing}>
                                        {isProcessing ? (
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                        ) : (
                                            'IRTPU'
                                        )
                                        }
                                    </Button>
                                </Col>
                                <Col xs={6} md={3}>
                                    <Button className="tripaction_btn_color tripaction_btn_width" onClick={handleDriverActionATLOCATION} value="AT LOCATION">
                                    {atlocationProcessing ? (
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> 
                                        ) : (
                                            'AT LOCATION'
                                            )
                                    }
                                    </Button>
                                </Col>
                                <Col xs={6} md={3}>
                                    <Button className="tripaction_btn_color tripaction_btn_width" onClick={handleDriverActionPU} value="PICKED UP">
                                    {pickedupProcessing ? (
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> 
                                        ) : (
                                            'PICKED UP'
                                            )
                                    }
                                    </Button>
                                </Col>
                                <Col xs={6} md={3}>
                                <Button className="tripaction_btn_color tripaction_btn_width" onClick={handleDriverActionDO} value="DROPPED OFF">
                                {droppedProcessing ? (
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> 
                                    ) : (
                                        'DROPPED OFF'
                                        )
                                } 
                                </Button>
                                </Col>
                            </Row> 
                        :""}
                        <Row className={`${props.gridType !== 'Complete' ? '' : 'd-none'}`}>
                            <Col colSpan="4">
                              <br/>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6} md={(props.gridType !== 'Complete' ? 3 : 4)}>
                                <Button className="tripaction_btn_color tripaction_btn_width" onClick={handleDriverActionDriverSearch} value="Driver Search">Driver Search</Button>
                            </Col>
                            {props.gridType !== 'Complete' ?
                                <>
                                    <Col xs={6} md={3}>
                                        <Button className="tripaction_btn_color tripaction_btn_width" onClick={handleDriverPenalty} value="PENALIZE">PENALIZE</Button>
                                    </Col>
                                    <Col xs={6} md={3}>
                                        <Button ref={favorRef} className="tripaction_btn_color tripaction_btn_width" onClick={handleDriverFavor} value="FAVOR">FAVOR</Button>
                                    </Col>
                                </>
                            : ""}
                            
                        </Row>
                        <Row className="tripaction_btn_seperator"></Row>
                        <Row>
                            <Col colSpan="4">
                                <hr></hr>
                            </Col>
                        </Row>
                        <h5 className="user-select-none">Admin Functions</h5>
                        <Row>
                            
                            {props.gridType !== 'Complete' ?
                                <>
                                    <Col xs={6} md={4}>
                                        <Button className="tripaction_btn_color tripaction_adminfunc_btn_width " onClick={handleSendNotification} value="SEND NOTIFICATION">Send Notification</Button>
                                    </Col>
                                    <Col xs={6} md={4}>
                                        <Button className="tripaction_btn_color tripaction_adminfunc_btn_width " onClick={handleAgentInstructionClick} value="Agent Instructions">Agent Instructions</Button>
                                    </Col>
                                    <Col xs={6} md={4}>
                                        <Button className="tripaction_btn_color tripaction_adminfunc_btn_width " onClick={handleColorCodes} value="COLOR CODES">Color Codes</Button>
                                    </Col>
                                </>
                                :
                                <Col xs={6} md={4}>
                                    <Button className="tripaction_btn_color tripaction_adminfunc_btn_width " onClick={handleEmailCustomerClick} value="Email Customer">
                                    {emailCustomerComponentLoad ? 
                                        (
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> 
                                        ) : 
                                        (
                                            'Email Customer'
                                        )
                                    }
                                    </Button>
                                </Col>
                            }
                           
                        </Row>
                        <Row className={`${props.gridType !== 'Complete' ? '' : 'd-none'}`}>
                            <Col colSpan="4">
                                <br/>
                            </Col>
                        </Row>
                        <Row className={`${props.gridType !== 'Complete' ? '' : 'd-none'}`}>
                            <Col xs={6} md={4}>    
                                <Button className="tripaction_btn_color tripaction_adminfunc_btn_width " onClick={handleEmailCustomerClick} value="Email Customer"> 
                                    {emailCustomerComponentLoad ? (
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> 
                                        ) : (
                                            'Email Customer'
                                        )
                                    }
                                </Button>
                            </Col>
                            <Col xs={6} md={4}>
                                
                            </Col>
                            <Col xs={6} md={4}>    
                                
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
            {irtpuComponentLoaded ? <IRTPU GridRowData={props.GridRowData} irtpuComponentLoaded={irtpuComponentLoaded} setIRTPUComponentLoad={setIRTPUComponentLoad} setIsProcessing={setIsProcessing} ReloadDataFunction={RefreshGridData}/> : ""}
            {atlocationComponentLoaded ? <AtLocation GridRowData={props.GridRowData} atlocationComponentLoaded={atlocationComponentLoaded} setATLOCATIONComponentLoad={setATLOCATIONComponentLoad} setAtLocationProcessing={setAtLocationProcessing}  ReloadDataFunction={RefreshGridData} /> : "" }
            {pickedupComponentLoaded ? <PickedUp GridRowData={props.GridRowData} pickedupComponentLoaded={pickedupComponentLoaded} setPickedUpComponentLoad={setPickedUpComponentLoad} setPickedUpProcessing={setPickedUpProcessing}  ReloadDataFunction={RefreshGridData}/> : "" }
            {droppedComponentLoaded ? <Dropped GridRowData={props.GridRowData} droppedComponentLoaded={droppedComponentLoaded} setDroppedComponentLoad={setDroppedComponentLoad} setDroppedProcessing={setDroppedProcessing} ReloadDataFunction={RefreshGridData} /> : "" }
            {sendNotificationComponentLoaded ? <SendNotificationActions GridRowData={props.GridRowData} sendNotificationComponentLoaded={sendNotificationComponentLoaded} setSendNotificationComponentLoad={setSendNotificationComponentLoad}  ReloadDataFunction={RefreshGridData} /> : ""}
            {driversearchComponentLoaded ? <DriverSearch AffiliateIDList={props.AffiliateIDList} GridRowData={props.GridRowData} driversearchComponentLoaded={driversearchComponentLoaded} setDriverSearchComponentLoad={setDriverSearchComponentLoad}  /> : "" }
            {agentInstructionComponentLoaded ? <AgentNotesDialog GridRowData={props.GridRowData} showAgentNotesDialog={agentInstructionComponentLoaded} setAgentNotesDialog={setAgentInstructionComponentLoad} /> : "" }
            {colorCodesComponentLoaded ? <ColorCodesActions AffiliateIDList={props.AffiliateIDList} ReloadDataFunction={props.ReloadDataFunction} GridRowData={props.GridRowData} colorCodesComponentLoaded={colorCodesComponentLoaded} setColorCodesComponentLoad={setColorCodesComponentLoad}  /> : ""}
            {emailCustomerComponentLoad ? <EmailCustomer GridRowData={props.GridRowData} emailCustomerComponentLoad={emailCustomerComponentLoad} setEmailCustomerComponentLoad={setEmailCustomerComponentLoad}  /> : "" }
            {showPenalty ? <Penalize GridRowData={props.GridRowData} showPenalty={showPenalty}  setShowPenalty={setShowPenalty}/> : "" }
            {showInOut ? <CabInOutForm GridRowData={props.GridRowData} showInOut={showInOut}  setShowInOut={setShowInOut}/> : ""}
            {showAlert ? <AlertBox showAlert={showAlert} setShowAlert={setShowAlert} title={title} body={body} />: ""}
        </>
        
    );
}
export default DriverActionsDialog;